<!--
Author: TangChen
Date: 2018-09-17
Desc: 用户信息展示组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-welcome bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="accountInfo">
            <el-col :span="14" class="circle-bg">
                <div class="act-info clear">
                    <img class="act-img" v-if="info.headimage" :src="info.headimage">
                    <img v-else class="act-img" :src="require('../../assets/img/account-img.png')">
                    <div class="act-basic">
                        <div class="user-info">
                            <p class="name">
                                欢迎您，<span
                                    class="k-text-flow"
                                    :class="{'mobilet':!info.custname}"
                                    :title="info.custname?info.custname:info.mobile"
                                >{{ info.custname?info.custname:(info.mobile?info.mobile:info.certificateno) }}</span>
                            </p>
                            <div class="info-lists">
                                <span class="act-bg" :class="{'is-ok':info.mobile.length===11}">
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="(info.mobile.length === 11)?'您的手机已绑定，号码为：'+info.mobile:'您还未绑定手机号，请立即前往'"
                                        placement="top"
                                    >
                                        <el-button class="act-info-btn" v-on:click="$router.push({name:$util.isEmpty(info.mobile)?'bindmobile':'checkmobile'})"><i
                                            class="fa fa-mobile"
                                            style="font-size: 18px;"
                                        /></el-button>
                                    </el-tooltip>
                                </span>
                                <span class="act-bg" :class="{'is-ok':info.activecardnum>0}">
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="info.activecardnum>0?'您已绑定'+info.activecardnum+'张银行卡':'您还未绑定银行卡，请立即前往'"
                                        placement="top"
                                    >
                                        <el-button class="act-info-btn" v-on:click="$router.push({name:'addbank'})"><i
                                            class="fa fa-credit-card"
                                        /></el-button>
                                    </el-tooltip>
                                </span>
                                <span v-if="info.professionflag!=='1'||info.professionexpired==='1'" class="act-bg" :class="{'is-ok':info.riskexpired==='0'}">
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="info.riskexpired==='0'?'您的风险等级为：'+$cache.getDict('100017',info.custrisk):(info.custrisk && info.custrisk.trim()?'你的风险评测已过期，当前风险'+$cache.getDict('100017',info.custrisk):'您还未做风险评测')+'，请立即评测'"
                                        placement="top"
                                    >
                                        <el-button class="act-info-btn" v-on:click="$router.push({name:'risk'})"><i
                                            class="fa fa-umbrella"
                                        /></el-button>
                                    </el-tooltip>
                                </span>
                                <span class="act-bg" :class="{'is-ok':info.needfillappro==='0'}">
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="info.needfillappro==='0'?'您的适当性信息已完善':'您的适当性信息尚未补录，请立即前往'"
                                        placement="top"
                                    >
                                        <el-button class="act-info-btn" v-on:click="$router.push({name:'infocollection'})"><i
                                            class="fa fa-pencil-square"
                                        /></el-button>
                                    </el-tooltip>
                                </span>
                                <span class="act-bg" :class="{'is-ok':info.needfillcrs==='0'}">
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="info.needfillcrs==='0'?'您的CRS信息已完善':'您的CRS信息尚未录入，请立即前往'"
                                        placement="top"
                                    >
                                        <el-button class="act-info-btn" v-on:click="$router.push({name:'taxeslist'})"><i
                                            class="fa fa-id-badge"
                                        /></el-button>
                                    </el-tooltip>
                                </span>
                            </div>
                        </div>
                        <div class="investor">
                            <span>完善信息：</span>
                            <el-progress
                                :stroke-width="10"
                                :percentage="perfect"
                                color="#1479d7"
                            />
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="10">
                <div class="login-info">
                    <p v-if="info.lastlogintime && info.lastlogintime!=='0'" class="login-time">
                        上次登录时间：<span>
                            {{ info.lastlogintime }}</span>
                    </p>
                    <p v-if="!info.lastlogintime||info.lastlogintime==='0'" class="login-time">
                        投资者类型：<span>
                            {{ (info.professionflag?$cache.getDict('120051', info.professionflag):'未知')+(info.professionflag==='1'&&info.professionexpired==='1'?'(已过期)':'') }}</span>
                    </p>
                    <p v-if="info.custname && info.usertype !== '2'" class="open-info">
                        <el-tooltip
                            class="item"
                            effect="info"
                            content="“预留信息”是为了帮助您有效识别网上交易系统，防范不法分子利用假网站进行诈骗的一项服务，您可以预先记录一段文字（即“预留信息”），当登录系统时，网页上会自动显示您的预留信息，以便您确认是否真实的网上交易系统。"
                            placement="top"
                        >
                            <i class="el-icon-question" />
                        </el-tooltip>
                        <i class="grey"> 预留信息：</i>
                        <span class="all-info k-text-flow" v-on:click="remarkShow=true" v-text="info.remark&&info.remark.trim()!==''?info.remark:'您未设置预留信息'" />
                    </p>
                    <p v-if="info.bindflag!=='1' && (!info.custname||info.usertype==='2')" class="open-info">
                        您还未绑定账户，<span v-on:click="info.usertype==='2'?$router.push('/securitycenter/bindnewacct'):$router.push('/securitycenter/bindacctway')">立即绑定账户</span>，开启基金之旅
                    </p>
                </div>
            </el-col>
        </el-row>
        <el-dialog
            :title="(info.remark&&info.remark!==' '?'修改':'新增')+'预留信息'"
            :visible.sync="remarkShow"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="100px"
                    size="small"
                >
                    <el-form-item label="预留信息：" prop="remark">
                        <el-input v-model="ruleForm.remark" type="text" :maxlength="64" placeholder="请输入预留信息" />
                    </el-form-item>
                    <el-form-item v-if="isPwdCheck" label="交易密码：" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="addRemark">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "Welcome",
    mixins: [mixin],
    data () {
        return {
            infoPer: 0, // 信息完善进度
            info: {},
            remarkShow: false,
            isPwdCheck: false,
            // 撤单密码校验
            ruleForm: {
                tradepwd: "",
                remark: ""
            },
            rules: {
                remark: [
                    { required: true, message: "请输入预留信息", trigger: "blur" }
                ],
                tradepwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            }
        };
    },
    computed: {
        // 计算属性的 getter
        perfect: function () {
            const a = ["mobile", "activecardnum", "riskexpired", "needfillappro", "needfillcrs"];
            let x = 0;
            for (let i of a) {
                if ((this.info[i] === "0" && i !== "activecardnum") || (i === "activecardnum" && this.info[i] > 0) || (i === "mobile" && ((this.info.bindflag === "1" && this.info.custname) || (this.info.mobile && !this.info.custname)))) {
                    x++;
                }
            }
            return x * 100 / a.length;
        }
    },
    created () {
        this.isPwdCheck = this.$cache.getPwdCheck("B1");
        this.info = this.$cache.getUser();
        const _this = this;
        this.$util.getProfession(data=>{
            _this.info = Object.assign({}, _this.info,data);
        });
    },
    methods: {
        // 新增或修改预留信息
        addRemark () {
            const _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    this.$util.request("acct/cust/profile", { remark: _this.ruleForm.remark, tradepwd: _pwd }, "PUT").then(res => {
                        if (res.data) {
                            _this.remarkShow = false;
                            _this.info.remark = _this.ruleForm.remark;
                            let _x = Object.assign({}, _this.info);
                            _this.$store.dispatch("setInfo", _x).then(() => {
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/* 用户信息 */
.bizcomp-welcome {
    .investor-tips {
        padding-top: 20px;
        .el-form-item {
            margin-bottom: 18px!important;
        }
    }
    .redemp-btn{margin-left: 3%;}
    .accountInfo {
        .login-info {
            padding: 19px 10px 19px 30px;
            p {
                line-height: 36px;
                color: $text-color1;
                &.login-time {
                    span {
                        color: $text-color3;
                    }
                }
                &.open-info {
                    text-overflow: ellipsis;
                    overflow: hidden;
                    .el-button.act-info-btn {
                        padding: 0;
                        border: 0;
                        border-radius: 100%;
                        margin-right: 5px;
                    }
                    i {
                        color: $color-b;
                        vertical-align: middle;
                        font-style: normal;
                        &.grey{color: $text-color3}
                    }
                    span {
                        color: $color-b;
                        cursor: pointer;
                        &.all-info{width: 70%;display: inline-block;height: 36px;vertical-align: middle;}
                        &:hover {
                            color: $color-a;
                        }
                    }
                }
            }
        }
        .act-info {
            padding: 19px 0;
            .act-img {
                margin-left: 16px;
                width: 80px;
                height: 80px;
                float: left;
                border-radius: 100% 100%;
                -webkit-border-radius: 100% 100%;
                overflow: hidden;
            }
            .act-basic {
                float: left;
                color: $text-color2;
                line-height: 24px;
                padding-left: 20px;
                p,
                .info-lists,
                .el-progress.el-progress--line {
                    display: inline-block;
                    vertical-align: middle;
                }
                .investor {
                    line-height: 24px;
                    color: $text-color2;
                    span {
                        vertical-align: middle;
                    }
                    .el-progress.el-progress--line {
                        .el-progress-bar {
                            width: 340px;
                        }
                        .el-progress__text {
                            color: $color-b;
                            font-size: $f14 !important;
                        }
                    }
                }
                .info-lists {
                    .act-bg {
                        margin-right: 14px;
                        display: inline-block;
                        vertical-align: middle;
                        span {
                            display: inline-block;
                            vertical-align: middle;
                            height: 24px;
                        }
                        &:last-child {
                            margin: 0;
                        }
                        .el-button.act-info-btn {
                            padding: 0;
                            border: 0;
                            border-radius: 100%;
                        }
                        i {
                            width: 24px;
                            height: 24px;
                            display: inline-block;
                            border-radius: 100%;
                            background: $bg9;
                            color: $text-color6;
                            font-size: $f16;
                            text-align: center;
                            line-height: 24px;
                        }
                        &.is-ok i {
                            background: $color-a;
                        }
                    }
                }
                .user-info {
                    line-height: 40px;
                    .name span {
                        font-size: $f24;
                        width: 160px;
                        display: inline-block;
                        vertical-align: middle;
                        &.mobilet {
                            font-size: $f18;
                        }
                    }
                }
            }
        }
    }
}
</style>
